import { VirtualObjectType } from '@spazious/dollhouse-graphql';
import { VirtualFurniture } from '@spazious/react-booking-engine';

export const mapFurniture = ({ id, attributes }: VirtualFurniture) => ({
  id: attributes!.uuid!.toString(),
  nid: parseInt(id.toString()),
  name: attributes!.name,
  model: attributes!.asset as any as string,
  type: VirtualObjectType.Furniture,
  objectType: attributes!.furnitureType as any as string,
  thumbnail: attributes!.thumbnail as any as string | null,
});
